import CoreService from "@/src/modules/core/services/core";
import {meService} from "@/src/modules/core/services/me";
import {useMeStore} from "@/src/modules/core/store/me";

import {panicButtonSettingsApi} from "../api";
import type {
  PanicButtonSettingsCatalog,
  PanicButtonSettingsResponse,
  PanicButtonSettingsUpdatePayload,
} from "../types";

class PanicButtonSettingsService extends CoreService {
  getCanShowSection(): boolean {
    if (useMeStore.getState().me?.isResident) {
      return false;
    }
    return meService.getHasPermission("panic_button_settings show");
  }

  getCanUpdate(): boolean {
    return meService.getHasPermission("panic_button_settings update");
  }

  async getCatalog(companyId: number): Promise<PanicButtonSettingsCatalog> {
    const {data} = await panicButtonSettingsApi.getCreate(companyId);
    return data.data;
  }

  async getSettings(companyId: number): Promise<PanicButtonSettingsResponse> {
    const {data} = await panicButtonSettingsApi.getSettings(companyId);
    return data.data;
  }

  async updateSettings(
    companyId: number,
    payload: PanicButtonSettingsUpdatePayload,
  ): Promise<PanicButtonSettingsResponse> {
    const {data} = await panicButtonSettingsApi.updateSettings(companyId, payload);
    return data.data;
  }
}

export const panicButtonSettingsService = new PanicButtonSettingsService();
